import { render, staticRenderFns } from "./orderListDet.vue?vue&type=template&id=073bc9d0&scoped=true"
import script from "./orderListDet.vue?vue&type=script&lang=js"
export * from "./orderListDet.vue?vue&type=script&lang=js"
import style0 from "./orderListDet.vue?vue&type=style&index=0&id=073bc9d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073bc9d0",
  null
  
)

export default component.exports